<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Parsed data from your csv file for importing to object <b>{{objName}}</b></p>
      </header>

      <section class="modal-card-body">
        <b-loading
          :is-full-page="false"
          :active.sync="loading"
          :can-cancel="false"
        ></b-loading>
        <div v-if="errors.length">
          <p class="subtitle is-4">CSV parsing errors:</p>
          <ol class="notification is-danger">
            <li
              v-for="(err,errIndx) in errors"
              :key="errIndx"
            >
              {{err.description}}
            </li>
          </ol>
        </div>

        <div v-if="importErrors.length">
          <p class="subtitle is-4">Parsed data saving errors:</p>
          <ol class="notification is-danger">
            <li
              v-for="(err,errIndx) in importErrors"
              :key="errIndx"
            >
              {{err.description}}
            </li>
          </ol>
          <br>
        </div>
        <div
          v-if="!errors.length"
          class="columns"
        >
          <div class="column is-one-fifth csv-column">
            <aside class="menu">
              <p class="menu-label">
                Configurations
              </p>
              <ul class="menu-list">
                <li
                  v-for="(conf,confIndx) in resultFields"
                  :key="confIndx"
                ><a :href='"#" + confIndx'>{{confIndx}}</a></li>
              </ul>
            </aside>
          </div>
          <div class="column csv-column">

            <div
              class="box"
              v-for="(conf,confIndx) in resultFields"
              :key="confIndx"
              :label="confIndx"
            >
              <a :name="confIndx"></a>
              <p class="title is-3">{{confIndx}}</p>

              <p class="subtitle is-5 has-text-centered">Configuration fields:</p>
              <!-- <p class="subtitle is-6">System fields: </p> -->

              <b-table :data="conf.fields">
                <template slot-scope="props">
                  <b-table-column
                    label="Field name"
                    field="name"
                    width="40"
                  >
                    {{props.row.name}}
                  </b-table-column>

                  <b-table-column
                    label="Default value"
                    field="edit"
                    width="40"
                  >
                    {{props.row.value}}
                  </b-table-column>

                  <b-table-column
                    label="Edit by customer"
                    field="edit"
                    width="40"
                    centered
                  >
                    <b-checkbox
                      type="is-info"
                      v-if="props.row.type===1"
                      v-model="props.row.edit"
                      :disabled="true"
                    ></b-checkbox>
                  </b-table-column>
                </template>

              </b-table>

              <br>
              <p class="subtitle is-5 has-text-centered">Room fields values:</p>
              <b-table
                v-if="conf.roomfieldsview.length"
                style="overflow:auto;background: #fafafa;"
                :data="bodyRooms(conf.roomfieldsview)"
                :columns="headRooms(conf.roomfieldsview)"
                width="500"
              >
              </b-table>

            </div>

          </div>
        </div>

      </section>

      <footer
        class="modal-card-foot columns is-gapless"
        v-if="!loading"
      >
        <div class="column is-half">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >Cancel</button>
        </div>

        <div class="column is-half has-text-right">
          <button
            v-if="!errors.length"
            class="button is-info "
            @click="isConfirm=true"
          >Data is correct. Import fields</button>
        </div>

      </footer>
    </div>

    <b-modal
      :active.sync="isConfirm"
      has-modal-card
    >
      <div
        class="modal-card"
        style="width: auto;"
      >
        <header class="modal-card-head">
          <span class="modal-card-title">Choose import variant

          </span>
        </header>

        <section class="modal-card-body">

          <div class="field">
            <b-radio
              v-model="importType"
              native-value="1"
              type="is-info"
              checked
            >
              Replace existing configuration fields, rooms, rooms fields, clients custom fields
            </b-radio>
          </div>

          <div class="field">
            <b-radio
              v-model="importType"
              native-value="2"
              type="is-danger"
            >
              Delete existing configuration fields, rooms, rooms fields, clients custom fields and save new
            </b-radio>
          </div>

        </section>
        <footer class="modal-card-foot columns is-gapless">
          <div class="column is-half">
            <button
              class="button"
              type="button"
              @click="isConfirm=false"
            >Cancel</button>
          </div>

          <div class="column is-half has-text-right">
            <button
              v-if="!errors.length"
              class="button is-info "
              @click="importFileds"
            >Import</button>
          </div>

        </footer>
      </div>

    </b-modal>

  </div>
</template>

<script>
export default {
  props: ['objectId', 'fields', 'errors', 'objName'],
  data() {
    return {
      importType: 1,
      isConfirm: false,
      loading: false,
      resultFields: this.fields,
      importErrors: []
    };
  },
  methods: {
    headRooms(fields) {
      return fields[0].map(f => {
        return {
          label: f.name,
          field: f.name
        };
      });
    },
    bodyRooms(fields) {
      return fields.map(f => {
        return f.reduce((p, c) => {
          p[c.name] = c.value;
          return p;
        }, {});
      });
    },
    importFileds() {
      this.loading = true;
      this.isConfirm = false;
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/object/settings/import`,
        transformResponse: [
          data => {
            return JSON.parse(data);
          }
        ],
        data: {
          objectId: this.objectId,
          fields: this.fields,
          importType: parseInt(this.importType)
        }
      })
        .then(response => {
          this.loading = false;

          if (response.data.status) {
            this.importErrors = response.data.errors;
            // this.$toast.open({
            //   message: response.data.error,
            //   position: 'is-bottom-right',
            //   type: 'is-danger',
            //   container: 'div.modal-card'
            // });
          } else {
            this.$parent.close();
            this.$emit('import_fields', {
              objectId: this.objectId,
              fields: this.fields
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.importErrors = response.data.errors;
          this.$toast.open({
            message: error,
            position: 'is-bottom-right',
            type: 'is-danger',
            container: 'div.modal-card'
          });
        });
    }
  },
  computed: {}
};
</script>

<style lang="scss">
.csv-column {
  max-height: calc(100vh - 300px) !important;
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .config-csv-modal {
    .modal-card {
      width: 100%;
    }
  }
}

@media screen and (min-width: 1024px) {
  .config-csv-modal {
    .modal-card {
      width: 1024px;
    }
    .animation-content {
      max-width: 1024 !important;
    }
  }
  .app-sidebar {
    z-index: 40;
  }
}

@media screen and (min-width: 1400px) {
  .config-csv-modal {
    .modal-card {
      width: 1400px;
    }
    .animation-content {
      max-width: 1400px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Importfields.vue?3a8dbe94